<script>
import $ from 'jquery';

export default {
    render() {
        return this.$scopedSlots.default();
    },

    mounted() {
        $(this.$el).each(function() {
            const dropdown = $(this).find('.js-dropdown');

            $(this).click(function(evt) {
                if (!(dropdown[0].contains(evt.target))) {
                    dropdown.toggleClass('open');
                    evt.preventDefault();
                    evt.stopPropagation();
                }
            });

            $(document).on('click', function(evt) {
                if (!dropdown[0].contains(evt.target) && dropdown.is('.open')) {
                    evt.preventDefault();
                    dropdown.removeClass('open');
                }
            });

            $(document).on('keyup', function(evt) {
                if (evt.key == 'Escape' && dropdown.is('.open')) {
                    evt.preventDefault();
                    dropdown.removeClass('open');
                }
            });
        });
    },
};
</script>
